import 'css-chunksrc/client/pages/costProfilesPage/resourcesList/styles.scss';export default {
  "scrolledList": "_scrolledList_1vtq8_1",
  "resourcesList": "_resourcesList_1vtq8_5",
  "item": "_item_1vtq8_9"
};